export const appearance = {
  theme: 'night',
  labels: 'floating',
  variables: {
    colorPrimary: '#FCD23E',
    colorBackground: '#14141A',
    colorText: 'white',
    colorTextSecondary: '#9494A8',
    colorTextPlaceholder: '#9494A8',
    colorDanger: '#FF8C9C',
    colorIconMenu: '#9494A8',
    fontFamily: 'Suisse Intl, system-ui, sans-serif',
    fontSmooth: 'always',
    borderRadius: '8px'
  },
  rules: {
    '.Tab--selected': {
      border: '1px solid #FCD23E',
      backgroundColor: '#14141A',
      color: 'white'
    },
    '.Tab--selected:hover': {
      color: 'white'
    },
    '.Tab--selected:focus': {
      border: '1px solid #FCD23E'
    },
    '.TabIcon--selected': {
      fill: 'white'
    },
    '.Input:focus': {
      border: '1px solid #282834',
      boxShadow: 'none'
    },
    '.PickerItem--new': {
      color: 'white'
    },
    '.PickerItem--selected': {
      border: '1px solid #FCD23E'
    },
    '.PickerItem--selected:hover': {
      border: '1px solid #FCD23E'
    },
    '.PickerItem--highlight': {
      boxShadow: 'none'
    },
    '.Action': {
      color: '#FCD23E'
    },
    '.MenuAction': {
      color: 'white'
    }
  }
};
